<template>
  <footer
    class="footer footer-black footer-big"
    :data-background-color="backgroundColor"
  >
    <template>
      <div class="container">
        <div class="content">
          <div class="md-layout">
            <div class="md-layout-item md-size-33 md-small-size-100">
              <h5>
                <img :src="aerLogo" alt="About AER" />
              </h5>
              <p>
                The <b>ASEAN Engineering Register (AER)</b> is on an important mission from 1998 to spearhead the mobility of engineers within ASEAN.
              </p>
              <p>
                This is in line with the ASEAN Secretarial Program for the liberalisation of professional services within ASEAN to prepare for globalisation under the World Trade Organization (WTO) initiative.
              </p>
            </div>

            <div class="md-layout-item md-size-33 md-small-size-100">
              <h5>
                <img :src="afeoLogo" alt="About AFEO" style="height: 55px" />
              </h5>
              <p>
                The <b>ASEAN Federation of Engineering Organisations (AFEO)</b> is a non-governmental body. Its members are the national institutions and organizations of engineers of ASEAN countries. AFEO formed the ASEAN Engineering Register (AER) in 1998.
              </p>
            </div>

              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <h5>Follow Us</h5>
                <ul class="social-buttons">
                  <li>
                    <md-button
                      href="https://www.facebook.com/ASEAN-Engineer-Register-110049274031437"
                      target="_blank"
                      class="md-facebook"
                    >
                      <i class="fab fa-facebook-square" /> Facebook
                    </md-button>
                  </li>
                  <li>
                    <md-button
                      href="https://www.linkedin.com/company/asean-engineering-register/"
                      target="_blank"
                      class="md-linkedin"
                    >
                      <i class="fab fa-linkedin" /> LinkedIn
                    </md-button>
                  </li>
                </ul>

                <h5>Numbers Don't Lie</h5>
                <h4>{{ engineerCount | formatNumber }} <small>Engineers</small></h4>
                <h4>{{ techCount | formatNumber }} <small>Technicians / Technologists</small></h4>
              </div>
          </div>
        </div>

        <hr>

        <div class="flex flex-direction-row space-between">
          <nav>
            <ul>
              <li>
                <router-link :to="{name:'about'}">
                  About Us
                </router-link>
              </li>
              <li>
                <router-link :to="{name:'privacy'}">
                  Privacy Policy
                </router-link>
              </li>
              <li>
                <router-link :to="{name:'contact'}">
                  Contact Us
                </router-link>
              </li>
            </ul>
          </nav>
          <div class="copyright float-right">
            Copyright © {{ year }} ASEAN Engineers Register
          </div>
        </div>
      </div>
    </template>
  </footer>
</template>
<script>
export default {
    props: {
        backgroundColor: String,
        type: String,
        size: String
    },
    computed: {
      engineerCount() {
        return this.$store.state.options.stats.engineer_count;
      },
      techCount() {
        return this.$store.state.options.stats.tech_count;
      }
    
    },
    data() {
        return {
          year: new Date().getFullYear(),
          aerLogo: require("@/assets/img/aer-logo-footer.png"),
          afeoLogo: require("@/assets/img/afeo-logo.png"),
          img1: require("@/assets/img/faces/card-profile6-square.jpg"),
          img2: require("@/assets/img/faces/christian.jpg"),
          img3: require("@/assets/img/faces/card-profile4-square.jpg"),
          img4: require("@/assets/img/faces/card-profile1-square.jpg"),
          img5: require("@/assets/img/faces/marc.jpg"),
          img6: require("@/assets/img/faces/kendall.jpg"),
          img7: require("@/assets/img/faces/card-profile5-square.jpg"),
          img8: require("@/assets/img/faces/card-profile2-square.jpg")
        };
    }
};
</script>
<style></style>
